/**
 * widgets/registry.mesh.tsx — ACM Mesh / Infrastruktura widgety (2.1).
 * Fleet multi-widget (role + topology + uzly), plus taby registry/health/…
 * Obsah beze ztráty z mesh.tsx / mesh-peers.tsx / TopologyPanel.
 */
import {
  Activity,
  Database,
  Key,
  Network,
  Plus,
  Radar,
  Shield,
  Users,
  Wifi,
} from 'lucide-react';
import type { WidgetSpec } from './types';
import {
  BootstrapWidgetPanel,
  DiscoveredWidgetPanel,
  EnrollmentWidgetPanel,
  HealthWidgetPanel,
  InfraFleetPanel,
  MeshRoleWidgetPanel,
  RoutingWidgetPanel,
  ResourcesWidgetPanel,
  SecurityWidgetPanel,
  TenantsWidgetPanel,
  TrustWidgetPanel,
} from '../pages/modules/mesh/panels';
import { MeshNodesGlanceWidget } from '../components/mesh/MeshNodesGlance';

export const MESH_WIDGETS: WidgetSpec[] = [
  {
    id: 'mesh.role',
    title: 'Node role',
    module: 'mesh',
    kind: 'stat',
    format: 'sm',
    formats: ['sm', 'md'],
    icon: Network,
    since: '2.1.0',
    component: MeshRoleWidgetPanel,
  },
  {
    // Glance list (dashboard / home). Není v MESH_FLEET — tab Uzly má NodeCard grid.
    id: 'mesh.topology',
    title: 'Mesh nodes — overview',
    module: 'mesh',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Radar,
    since: '2.1.0',
    component: MeshNodesGlanceWidget,
  },
  {
    id: 'mesh.fleet',
    title: 'Nodes',
    module: 'mesh',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Network,
    since: '2.1.0',
    component: InfraFleetPanel,
  },
  {
    id: 'mesh.resources',
    title: 'Registry resources',
    module: 'mesh',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Database,
    since: '2.1.0',
    component: ResourcesWidgetPanel,
  },
  {
    id: 'mesh.health',
    title: 'Mesh health',
    module: 'mesh',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Activity,
    since: '2.1.0',
    component: HealthWidgetPanel,
  },
  {
    id: 'mesh.routing',
    title: 'Routing & quorum',
    module: 'mesh',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Network,
    since: '2.2.0',
    component: RoutingWidgetPanel,
  },
  {
    id: 'mesh.enrollment',
    title: 'Add node',
    module: 'mesh',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Plus,
    since: '2.1.0',
    component: EnrollmentWidgetPanel,
  },
  {
    id: 'mesh.discovered',
    title: 'Discovered',
    module: 'mesh',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Wifi,
    since: '2.1.0',
    component: DiscoveredWidgetPanel,
  },
  {
    id: 'mesh.bootstrap',
    title: 'Bootstrap',
    module: 'mesh',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Key,
    since: '2.1.0',
    component: BootstrapWidgetPanel,
  },
  {
    id: 'mesh.security',
    title: 'Security findings',
    module: 'mesh',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Shield,
    since: '2.1.0',
    component: SecurityWidgetPanel,
  },
  {
    id: 'mesh.trust',
    title: 'Trust relations',
    module: 'mesh',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Shield,
    since: '2.1.0',
    component: TrustWidgetPanel,
  },
  {
    id: 'mesh.tenants',
    title: 'Tenants',
    module: 'mesh',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Users,
    since: '2.1.0',
    component: TenantsWidgetPanel,
  },
];
